var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconSpeedE58N3Cqly7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#48bdff;}.cls-2{fill:#e8f0fb;}.cls-3{fill:#2d98f6;}.cls-4{fill:#b9d5ea;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "speed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speed"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,20.2A12,12,0,1,0,12,20v2.06A9,9,0,0,0,13,40H34a10,10,0,0,0,2-19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.64,36H18.36C11.75,30.74,15.54,20,24,20S36.23,30.76,29.64,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,37H15a1,1,0,0,1,0-2H33A1,1,0,0,1,33,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24,34a2,2,0,1,1,2-2A2,2,0,0,1,24,34Zm0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23,31V27a1,1,0,0,1,2,0v4A1,1,0,0,1,23,31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17,30H15.06a8.36,8.36,0,0,1,0-2H17A1,1,0,0,1,17,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.94,30H31a1,1,0,0,1,0-2h1.94A8.36,8.36,0,0,1,32.94,30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25,20.06V22a1,1,0,0,1-2,0V20.06A8.36,8.36,0,0,1,25,20.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31,23.39c-1.45,1.46-1.53,1.66-2.07,1.66a1,1,0,0,1-.71-1.71L29.61,22A7.24,7.24,0,0,1,31,23.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.34,24.76,17,23.39A7.24,7.24,0,0,1,18.39,22l1.37,1.36A1,1,0,0,1,18.34,24.76Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconSpeedE58N3Cqly7);
export default __webpack_public_path__ + "static/media/reshot-icon-speed-E58N3CQLY7.e767e2a188e9c854619b6178b784b253.svg";
export { ForwardRef as ReactComponent };